import * as React from "react";

const PlaylistIcon = (props) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-1 5.732L13 11l-3-1.732v3.464Z"
      fill="url(#a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-1 5.732L13 11l-3-1.732v3.464Z"
      fill="#fff"
      fillOpacity={0.2}
    />
    <path
      stroke="url(#b)"
      strokeWidth={1.529}
      strokeLinecap="round"
      d="M.764 1.236h10.894"
    />
    <path
      stroke="#fff"
      strokeOpacity={0.2}
      strokeWidth={1.529}
      strokeLinecap="round"
      d="M.764 1.236h10.894"
    />
    <path
      stroke="url(#c)"
      strokeWidth={1.529}
      strokeLinecap="round"
      d="M.764 4.544h10.894"
    />
    <path
      stroke="#fff"
      strokeOpacity={0.2}
      strokeWidth={1.529}
      strokeLinecap="round"
      d="M.764 4.544h10.894"
    />
    <path
      stroke="url(#d)"
      strokeWidth={1.529}
      strokeLinecap="round"
      d="M.764 7.685h5.097"
    />
    <path
      stroke="#fff"
      strokeOpacity={0.2}
      strokeWidth={1.529}
      strokeLinecap="round"
      d="M.764 7.685h5.097"
    />
    <defs>
      <linearGradient
        id="a"
        x1={8.376}
        y1={7.846}
        x2={15.71}
        y2={9.528}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={2.137}
        y1={2.106}
        x2={3.451}
        y2={5.851}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={2.137}
        y1={5.414}
        x2={3.451}
        y2={9.16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={1.14}
        y1={8.555}
        x2={3.071}
        y2={11.491}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
);

export default PlaylistIcon;
